import { submitShortcutAria, submitShortcutLabel } from '../../../../utils/submit-shortcut';
import { KeyHint } from '../../../shared/KeyHint';

const SUBMIT_LABELS = {
  add: { idle: 'Add replacement', saving: 'Adding…' },
  edit: { idle: 'Save', saving: 'Saving…' },
} as const;

/** Cancel and submit for the add and edit forms. */
export function TreeReplacementModalFooter({
  mode,
  formId,
  saving,
  onCancel,
}: {
  mode: keyof typeof SUBMIT_LABELS;
  formId: string;
  saving: boolean;
  onCancel: () => void;
}) {
  const labels = SUBMIT_LABELS[mode];
  return (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
      <button type="button" className="nb-btn nb-btn-ghost" onClick={onCancel} disabled={saving}>
        Cancel
      </button>
      <button
        type="button"
        className="nb-btn nb-btn-primary"
        disabled={saving}
        aria-keyshortcuts={submitShortcutAria()}
        onClick={() => (document.getElementById(formId) as HTMLFormElement | null)?.requestSubmit()}
      >
        {saving ? labels.saving : labels.idle}
        {!saving && <KeyHint keys={submitShortcutLabel()} />}
      </button>
    </div>
  );
}
